import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-management-and-entreprenuership',
  imports: [PillarPagesTemp],
  templateUrl: './management-and-entreprenuership.html',
  styleUrl: './management-and-entreprenuership.scss',
})
export class ManagementAndEntreprenuership {

}
